import React from "react";
import AssetGrid from "./AssetGrid";

interface HeroAdsTabProps {
  assets: BrandAsset[];
  projectId: string;
  onUpload: (file: File) => Promise<void>;
  onDelete: (assetId: string) => void;
  onUpdate: (assetId: string, updates: FormData) => void;
}

const HeroAdsTab: React.FC<HeroAdsTabProps> = ({ assets, projectId, onUpload, onDelete, onUpdate }) => {
  const heroAds = assets.filter((a) => a.type === "hero_ad");

  const setAttribution = (asset: BrandAsset, attribution: HeroAdAttribution) => {
    const fd = new FormData();
    fd.append(
      "metadata",
      JSON.stringify({ ...(asset.metadata ?? {}), attribution }),
    );
    onUpdate(asset.id, fd);
  };

  const toggleFeatured = (asset: BrandAsset) => {
    const fd = new FormData();
    fd.append(
      "metadata",
      JSON.stringify({
        ...(asset.metadata ?? {}),
        featured: !asset.metadata?.featured,
      }),
    );
    onUpdate(asset.id, fd);
  };

  const renderMeta = (asset: BrandAsset) => {
    const attribution = (asset.metadata?.attribution as HeroAdAttribution | undefined) ?? "own";
    const featured = !!asset.metadata?.featured;
    return (
      <div className="flex flex-col gap-2 w-full">
        <div className="flex items-center gap-3 text-xs text-gray-300">
          <label className="flex items-center gap-1 cursor-pointer">
            <input
              type="radio"
              name={`attribution-${asset.id}`}
              checked={attribution === "own"}
              onChange={() => setAttribution(asset, "own")}
            />
            Own
          </label>
          <label className="flex items-center gap-1 cursor-pointer">
            <input
              type="radio"
              name={`attribution-${asset.id}`}
              checked={attribution === "aspiration"}
              onChange={() => setAttribution(asset, "aspiration")}
            />
            Aspiration
          </label>
        </div>
        <label className="flex items-center gap-1 cursor-pointer text-xs text-gray-300">
          <input type="checkbox" checked={featured} onChange={() => toggleFeatured(asset)} />
          Featured (override — only featured hero ads will be sent to generations)
        </label>
      </div>
    );
  };

  return (
    <AssetGrid
      assets={heroAds}
      assetType="hero_ad"
      onUpload={onUpload}
      onDelete={onDelete}
      onUpdate={onUpdate}
      renderMeta={renderMeta}
      emptyMessage="No hero ads yet. Upload your best past ads (or aspirational references) to steer generations."
    />
  );
};

export default HeroAdsTab;
